function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import PropTypes from "prop-types";
import React, { Component } from "react";
import classnames from "classnames";
import Base from "../Base/Base";
import ImageFallback from "./ImageFallback";
import "./Image.css";
export default class Image extends Component {
  render() {
    const {
      border,
      children,
      color,
      height,
      maxWidth,
      onError,
      onLoad,
      shape,
      src,
      width,
      ...rest
    } = this.props;
    const style = {
      maxWidth,
      width: shape === "circle" ? width || height : width,
      height: shape === "circle" ? width || height : height,
      backgroundColor: color
    };
    const classes = classnames("ax-image", `ax-image--${shape}`, {
      [`ax-image--border-${border}`]: border
    });
    return /*#__PURE__*/React.createElement(ImageFallback, {
      fallback: children,
      onError: onError,
      onLoad: onLoad,
      src: src
    }, /*#__PURE__*/React.createElement(Base, _extends({
      space: "x4"
    }, rest, {
      Component: "img",
      className: classes,
      src: src,
      style: style
    })));
  }

}

_defineProperty(Image, "defaultProps", {
  maxWidth: "100%",
  shape: "square"
});